'use client';

import ErrorBoundary from '@/components/ErrorBoundary';

export default function ErrorBoundaryWrapper({ children }) {
  return <ErrorBoundary>{children}</ErrorBoundary>;
}
